export default __webpack_public_path__ + "static/testimonial-1-a110ddced870705d7a8cd75576ec0777.jpg";